import React, { useState } from "react";
import "./Payment.css";
import { useLocation, useNavigate } from "react-router-dom";

const Payment = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const packageName = location.state?.packageName || "ZikRme Dream Vacation";
  const email = location.state?.email || "user@email.com";
  const date = location.state?.date || "Not Selected";

  const amount = location.state?.amount || "23600";
  const [method, setMethod] = useState("UPI");
  const [agree, setAgree] = useState(false);
  const [error, setError] = useState("");

  const handlePayment = () => {
    // Checkbox validation
    if (!agree) {
      setError("You must agree to the terms and conditions");
      return;
    }

    setError("");

    // Simulating payment
    const isSuccess = Math.random() > 0.3;

    if (isSuccess) {
    navigate("/success", {
      state: {
        packageName: packageName,
        email: email,
        date: date,
        amount: amount,
      },
    });
    } else {
       navigate("/failed", {
         state: {
           packageName,
         },
       });
    }
  };

  return (
    <div className="payment-container">
      <div className="payment-box">
        <h2 className="payment-heading">Secure Payment</h2>

        <div className="amount-box">
          <p>Amount to Pay</p>
          <h1>₹{amount}</h1>
        </div>

        <label className="label">Payment Method</label>
        <select
          className="payment-select"
          value={method}
          onChange={(e) => setMethod(e.target.value)}
        >
          <option value="UPI">UPI (Instant)</option>
          <option value="NetBanking">Net Banking</option>
          <option value="Card">Credit / Debit Card</option>
          <option value="PayPal">Pay Pal</option>
        </select>

        {/* UPI */}
        {method === "UPI" && (
          <>
            <div className="upi-buttons">
              <button>Google Pay</button>
              <button>PhonePe</button>
              <button>Paytm</button>
            </div>

            <input
              type="text"
              className="upi-input"
              placeholder="Enter UPI ID"
            />
          </>
        )}

        {/* Net Banking */}
        {method === "NetBanking" && (
          <select className="payment-select">
            <option>SBI</option>
            <option>HDFC</option>
            <option>ICICI</option>
            <option>Axis</option>
          </select>
        )}

        {/* Card */}
        {method === "Card" && (
          <>
            <input className="upi-input" placeholder="Cardholder Name" />
            <input className="upi-input" placeholder="Card Number" />

            <div style={{ display: "flex", gap: "12px" }}>
              <input className="upi-input" placeholder="MM/YY" />
              <input className="upi-input" placeholder="CVV" />
            </div>
          </>
        )}

        {/* Checkbox */}
        <div className="checkbox-text">
          <input
            type="checkbox"
            checked={agree}
            onChange={(e) => {
              setAgree(e.target.checked);
              setError("");
            }}
          />
          <p>
            I agree to receiving marketing emails from ZikRme, including
            promotions, personalised recommendations, and travel updates.
          </p>
        </div>

        {/* Error */}
        {error && <p className="error">{error}</p>}

        <div className="term-condiotion-policy">
          <h3>Terms & Legal</h3>
          <p>
            Your booking is directly with {packageName}. By clicking 'Book
            Now', you acknowledge that you have read and accepted our [Standard
            Booking Conditions], [General Terms of Service], and [Privacy
            Policy]. All transactions are secured and encrypted.
          </p>
        </div>

        <button className="book-btn" onClick={handlePayment}>
          Book Now
        </button>
      </div>
    </div>
  );
};

export default Payment;
